'use strict';

angular.module('upResources').factory('UserDefinedCategory', [
	'$resource',
	'$q',
	'URL',
	'API',
	'UserDefinedCategoryAttributes',
	'RequestBuilder',
	'CacheService',
	function UserDefinedCategory($resource, $q, URL, API, UserDefinedCategoryAttributes, RequestBuilder, CacheService) {
		var AA = UserDefinedCategoryAttributes();
		var Attribute = AA.attr;
		var Keys = AA.keys;

		var Category = $resource(
			URL + API + 'userDefinedObjectCategories/:udoFieldId/:id',
			{},
			{
				query: { method: 'GET', isArray: false },
				create: { method: 'POST', isArray: false },
				update: { method: 'PUT', isArray: false }
			}
		);

		var Model = {
			setId: function (udoFieldId) {
				Model.udoFieldId = udoFieldId;

				return Model;
			},
			find: function (filter, options) {
				var defered = $q.defer();
				var params = angular.extend(filter, options);
				params.udoFieldId = Model.udoFieldId;

				Category.get(
					params,
					function (response) {
						defered.resolve(response);
					},
					function (response) {
						defered.reject(response.status);
					}
				);

				return defered.promise;
			},

			get: function (id) {
				if (!id) {
					return $q.reject('no category id');
				}

				return Category.get({ id: id, udoFieldId: Model.udoFieldId }).$promise;
			},
			attr: Attribute,
			keys: Keys
		};

		return Model;
	}
]);
